import React from "react";
import {
  withCartIdParam,
  addParamToURL
} from "../../../../utils/BrowserHelper";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";
import SaveIcon from "../vectors/SaveIcon";

interface AdminDownloadSaveSectionProps {
  photo: { id: string };
  photoSaved: boolean;
  primaryColor: string;
  handleSave: () => void;
  handleUnsave: () => void;
  handleToggle: (id: string, msg: string) => void;
  handleHideTooltip: () => void;
  userId: string | null;
  cartId: number;
  isEmbed: boolean;
}

const AdminDownloadSaveSection: React.FC<AdminDownloadSaveSectionProps> = ({
  photo,
  photoSaved,
  primaryColor,
  handleSave,
  handleUnsave,
  handleToggle,
  handleHideTooltip,
  userId,
  cartId,
  isEmbed
}) => (
  <div className="download-save-btns" id="save-tooltip">
    <button
      data-toggle="tooltip"
      data-placement="bottom"
      onMouseEnter={() =>
        handleToggle(
          "save-tooltip",
          photoSaved ? "Unsave Photo" : "Save for later"
        )
      }
      // @ts-ignore TODO: fix this
      onMouseLeave={handleHideTooltip}
      className="save-btn"
      onClick={() => (photoSaved ? handleUnsave() : handleSave())}
      style={{
        border: `1px solid ${
          photoSaved
            ? "gray"
            : ContrastForegroundUtility.lbFgColor(primaryColor)
        }`
      }}
    >
      <SaveIcon
        color={
          photoSaved
            ? "gray"
            : ContrastForegroundUtility.lbFgColor(primaryColor)
        }
      />
    </button>
    <a
      href={addParamToURL(
        withCartIdParam(`/api/v1/photos/${photo.id}/download`, cartId, isEmbed),
        "user_id",
        userId!
      )}
      target="_blank"
      className="geo-btn geo-btn--secondary geo-btn--caps"
      style={{
        backgroundColor: ContrastForegroundUtility.lbFgColor(primaryColor),
        height: 44,
        width: 44
      }}
    >
      <span className="fa fa-download" style={{ color: "white" }} />
    </a>
  </div>
);

export default AdminDownloadSaveSection;
